import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Paper, Typography, makeStyles } from "@material-ui/core";
import { Panel } from "../../../panel";
import { addRegisteredLayout } from "../layoutDescriptions";
import { ThemeProvider } from "@material-ui/core/styles";
import { columnsSummaryHeaderTheme, useStyles, actionsTheme } from "./styles";
import clsx from "clsx";
import FormStatus from "../../../components/FormStatus";
import { useAppLoad } from "../../../appLoadContext";
const commonColumnPanelSettings = {
    editableOptions: {
        title: true,
        elevation: true,
        square: true
    }
};
const summaryHeaderPanelSettings = {
    editableOptions: {
        title: false,
        elevation: true,
        square: true
    }
};
const panels = {
    summaryHeader: summaryHeaderPanelSettings,
    column1: commonColumnPanelSettings,
    column2: commonColumnPanelSettings,
    column3: commonColumnPanelSettings,
    actions: {},
    appActions: {}
};
addRegisteredLayout({
    name: "ThreeColumns",
    displayName: "ThreeColumns",
    panels
});
const useThreeColumnsStyle = makeStyles(theme => ({
    threeColumnPadding: {
        padding: 0
    }
}));
export function ThreeColumns(props) {
    const classes = useStyles(props);
    const threeColumnsStyle = useThreeColumnsStyle(props);
    const { header, panels } = props;
    const { summaryHeader, column1, column2, column3, actions, appActions } = panels;
    const { vulcanContext } = useAppLoad();
    return (_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, md: 4, container: true, alignItems: "flex-start", children: header }), _jsx(Grid, { item: true, md: 4, container: true, alignItems: "stretch", children: summaryHeader && (_jsx(ThemeProvider, { theme: columnsSummaryHeaderTheme, children: _jsx(Panel, { ...summaryHeader, className: classes.summaryHeader }) })) }), _jsx(Grid, { item: true, md: 4, container: true, alignItems: "stretch", wrap: "nowrap", justifyContent: "flex-end", children: appActions && (_jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { ...appActions, className: classes.actionsPanel }) })) })] }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(FormStatus, {}) }), _jsx(Grid, { item: true, xs: 12, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, md: 4, xs: 12, children: column1 && (_jsxs(Paper, { elevation: 0, children: [column1.panelTitle && (_jsx(Typography, { variant: "h6", className: classes.mainSectionsHeader, children: column1.panelTitle })), _jsx(Panel, { className: clsx(classes.mainSections, threeColumnsStyle.threeColumnPadding), ...column1 })] })) }), _jsx(Grid, { item: true, md: 4, xs: 12, children: column2 && (_jsxs(Paper, { elevation: 0, children: [column2.panelTitle && (_jsx(Typography, { variant: "h6", className: classes.mainSectionsHeader, children: column2.panelTitle })), _jsx(Panel, { className: clsx(classes.mainSections, threeColumnsStyle.threeColumnPadding), ...column2 })] })) }), _jsx(Grid, { item: true, md: 4, xs: 12, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: column3 && (_jsxs(Paper, { elevation: 0, children: [column3.panelTitle && (_jsx(Typography, { variant: "h6", className: classes.mainSectionsHeader, children: column3.panelTitle })), _jsx(Panel, { className: clsx(classes.mainSections, threeColumnsStyle.threeColumnPadding), ...column3 })] })) }), _jsx(Grid, { item: true, xs: 12, children: actions && vulcanContext !== "PostProcess" && (_jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { justifyContent: "flex-end", transparent: true, fullWidth: true, ...actions }) })) })] }) })] }) })] }));
}
//# sourceMappingURL=ThreeColumns.js.map